import { FeatureAndAdjustmentRow } from './types.ts';

export const marketAdjustments: FeatureAndAdjustmentRow[] = [
  { path: 'termsOfSale', alwaysShow: true, suppressDetails: true },
  { path: 'concessions', alwaysShow: true, suppressDetails: true },
  { path: 'dateOfSale', alwaysShow: true },
];

export const depreciatedCostAdjustmentsBeforeMainDwelling: FeatureAndAdjustmentRow[] = [
  { path: 'quality', alwaysShow: true },
  { path: 'condition', alwaysShow: true },
];

export const depreciatedCostAdjustmentsAfterMainDwelling: FeatureAndAdjustmentRow[] = [
  { path: 'bathAboveGrade', alwaysShow: true },
  { path: 'basement', alwaysShow: false },
  { path: 'bathBelowGrade', alwaysShow: false },
  { path: 'functionalUtility', alwaysShow: false },
  { path: 'externalObsolescence', alwaysShow: false },
  { path: 'garageCarport', alwaysShow: false },
  { path: 'porchPatioDeck', alwaysShow: false },
  { path: 'attic', alwaysShow: false },
  { path: 'belowGradeANSI', alwaysShow: false },
  { path: 'fireplace', alwaysShow: false },
  { path: 'barn', alwaysShow: false },
  { path: 'bonusRoom', alwaysShow: false },
  { path: 'adu', alwaysShow: false },
  { path: 'manufactured', alwaysShow: false },
  { path: 'pool', alwaysShow: false },
  { path: 'shed', alwaysShow: false },
  { path: 'workshop', alwaysShow: false },
  { path: 'manual', alwaysShow: false },
];
